// bao migrate skip
// bao migrate - module not found: import Connection from "signal-r/hub/connection";
// bao migrate - module not found: import Proxy from "signal-r/hub/proxy";
// bao migrate - module not found: import IMessageBusEventHandler from "message-bus/imessage-bus-event-handler";

import * as $ from "jquery";
import Bao from "./bao-service";
import * as signalR from "@microsoft/signalr";

export class MessageBus implements IMessageBus {
    private connection: signalR.HubConnection;
    private initConnectionDeferred: Promise<any>;
    subscribe(eventHandlers: IMessageBusEventHandler[]): Promise<void> {
        let deferred = $.Deferred<void>();
        // Initialize hub connection and proxy when subscribe is called for the first time
        // The reason for passing eventHandlers here is that at least one event handler has to be registered before starting the connection
        if (!this.initConnectionDeferred) {
            this.initConnection(eventHandlers);
            return this.initConnectionDeferred;
        }
        // Add handlers to an existing connection
        return this.initConnectionDeferred
            .then(() => {
                this.setEventHandlers(eventHandlers);
            });
    }
    private initConnection(eventHandlers: IMessageBusEventHandler[]) {
        // Get session information
        this.initConnectionDeferred = new Promise<void>((resolve, reject) => {
            Bao.post('Bao/GetSessionInformation')
                .then((result) => {
                    const sessionId = result.SessionId;
                    const baoToken = result.TokenId;
                    const mandatorId = result.MandatorId;
                    const userId = result.UserId;
                    // Create hub connection
                    this.connection = new signalR.HubConnectionBuilder()
                    .withUrl((Bao.AbsolutePath !== "/" ? Bao.AbsolutePath : "") + "message?sessionid=" + sessionId + "&baotoken=" + baoToken + "&mandatorid=" + mandatorId)
                       .configureLogging(signalR.LogLevel.Information)
                        .withAutomaticReconnect()
                        .build();

                    // Register event handlers
                    this.setEventHandlers(eventHandlers);

                    // Register event handlers
                    // Start hub connection and subscribe to specified groups (mandatorId & userId by default)
                    this.startConnection([mandatorId, userId])
                        .finally(() => {
                            // Reconnect when connection has been interrupted
                            resolve();
                            this.connection.onclose(() => {
                                setTimeout(() => {
                                    this.startConnection([mandatorId, userId]);
                                }, 5000);
                            })
                        });
                });
        });
        return this.initConnectionDeferred;
    }
    unsubscribe(eventHandlers: IMessageBusEventHandler[]) {
        if (this.connection && eventHandlers) {
            eventHandlers.forEach(e => this.connection.off(e.name, e.handler));
        }
    }
    joinGroup(groupNames: string | string[]): Promise<void> {
        if (this.connection) {
            if (!Array.isArray(groupNames)) {
                groupNames = [groupNames];
            }
            return this.connection.invoke("JoinGroup", groupNames);
        }
        else {
            return Promise.reject();
        }
    }
    leaveGroup(groupNames: string | string[]): Promise<void> {
        if (this.connection) {
            if (!Array.isArray(groupNames)) {
                groupNames = [groupNames];
            }
            return this.connection.invoke("LeaveGroup", groupNames);
        }
        else {
            return Promise.reject();
        }
    }
    private startConnection(groupNames: string[]): Promise<void> {
        return this.connection.start()
            .then(() => {
                this.connection.invoke("JoinGroup", groupNames);
            });
    }
    private setEventHandlers(eventHandlers: IMessageBusEventHandler[]) {
        if (eventHandlers) {
            eventHandlers.forEach(e => this.connection.on(e.name, e.handler));
        }
    }
}
export default new MessageBus();

export interface IMessageBus {
    /**
     * Subscribe to event handlers. Starts the hub connection if it is not already started 
     */
    subscribe(eventHandlers: IMessageBusEventHandler[]): Promise<void>

    /**
     * Unsubscribe from event handlers
     */
    unsubscribe(eventHandlers: IMessageBusEventHandler[])

    /**
     * Join to group(s)
     */
    joinGroup(groupNames: string | string[]): Promise<void>

    /**
     * Leave from group(s)
     */
    leaveGroup(groupNames: string | string[]): Promise<void>
}

export interface IMessageBusEventHandler {
    name: string;
    handler: (result: any) => void;
}